import { render, staticRenderFns } from "./ClaimDialog.vue?vue&type=template&id=a1b85b28&scoped=true&"
import script from "./ClaimDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimDialog.vue?vue&type=script&lang=js&"
import style0 from "./ClaimDialog.vue?vue&type=style&index=0&id=a1b85b28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b85b28",
  null
  
)

export default component.exports